import { observable } from 'mobx';
import type { TransitPriceResponseArgs } from './transit_price';
import TransitPrice, { convertTransitPriceResponseToArgs } from './transit_price';
import type { LegSummaryTerminalResponseArgs } from './leg_summary_terminal';
import LegSummaryTerminal, { convertLegSummaryTerminalResponseToArgs } from './leg_summary_terminal';

export type LegSummaryResponseArgs = {
  type: string;
  indexes: string[];
  from: LegSummaryTerminalResponseArgs;
  to: LegSummaryTerminalResponseArgs;
  name: string | null;
  price: number | null;
  prices: TransitPriceResponseArgs[] | null;
  stations: number | null;
  totaltime: string | null;
  transitcount: number | null;
};

export type LegSummaryArgs = {
  type: string;
  indexes: string[];
  from: LegSummaryTerminal;
  to: LegSummaryTerminal;
  name: string | null;
  price: number | null;
  prices: TransitPrice[];
  stations: number | null;
  totaltime: string | null;
  transitcount: number | null;
};

export const convertLegSummaryResponseToArgs = (response: LegSummaryResponseArgs) => {
  const args: LegSummaryArgs = {
    type: response.type,
    indexes: response.indexes,
    from: new LegSummaryTerminal(convertLegSummaryTerminalResponseToArgs(response.from)),
    to: new LegSummaryTerminal(convertLegSummaryTerminalResponseToArgs(response.to)),
    name: response.name,
    price: response.price,
    prices: response.prices
      ? response.prices.map(raw => new TransitPrice(convertTransitPriceResponseToArgs(raw)))
      : [],
    stations: response.stations,
    totaltime: response.totaltime,
    transitcount: response.transitcount
  };
  return args;
};

export default class LegSummary {
  @observable type: string;
  @observable indexes: string[];
  @observable from: LegSummaryTerminal;
  @observable to: LegSummaryTerminal;
  @observable name: string | null;
  @observable price: number | null;
  @observable prices: TransitPrice[];
  @observable stations: number | null;
  @observable totaltime: string | null;
  @observable transitcount: number | null;

  constructor(args: LegSummaryArgs) {
    this.type = args.type;
    this.indexes = args.indexes;
    this.from = args.from;
    this.to = args.to;
    this.name = args.name;
    this.price = args.price;
    this.prices = args.prices;
    this.stations = args.stations;
    this.totaltime = args.totaltime;
    this.transitcount = args.transitcount;
  }
}
